/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCreateMessageModel,
  ICreateMessageRequest,
  IMappers,
  ICreateMessageResponse,
  ICreateMessageResponseError,
  TCreateMessageResponse,
} from './types';

const defaultConfig: TCreateMessageModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'demand',
  pathApi: '/v2/create-message/',
  hostType: 'ud-api',
} as TCreateMessageModel;

function createCreateMessageModel(parameters: ICreateMessageRequest): TCreateMessageModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateMessageOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICreateMessageRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCreateMessage<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICreateMessageOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TCreateMessageResponse> {
  const { response, statusCode } = await httpApi.fetch(createCreateMessageModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateMessageResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICreateMessageResponseError);
    }
  }

  return { response, statusCode } as TCreateMessageResponse;
}

export { defaultConfig, createCreateMessageModel, fetchCreateMessage };
